import { render, staticRenderFns } from "./indTree.vue?vue&type=template&id=2b823431&scoped=true&"
import script from "./indTree.vue?vue&type=script&lang=js&"
export * from "./indTree.vue?vue&type=script&lang=js&"
import style0 from "./indTree.vue?vue&type=style&index=0&id=2b823431&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b823431",
  null
  
)

export default component.exports